// Resources
import React, { useState } from 'react';
import SidePanel from './SidePanel';
import dayjs from 'dayjs';

// Icons
import { TfiBackRight } from 'react-icons/tfi';
import { FaRegClock } from 'react-icons/fa';

import { NODE_THEMES } from '../Components/NodeTheme';

const ACCENT = '#0a7ba5';

const HistoryVersions = ({
  selectLog,
  handleShowLogs,
  listLogs,
  animateClass,
  isDark,
}) => {
  const theme = isDark == 'true' ? NODE_THEMES.dark : NODE_THEMES.light;
  const [selectedLog, setSelectedLog] = useState(null);

  const hasLogs = listLogs && listLogs.length > 0;

  return (
    <SidePanel title="Historial de versiones" onClose={handleShowLogs}>
      {/* Cuerpo */}
      <div id="content-list-chats" style={{ overflowY: 'auto', padding: '14px' }}>
        {!hasLogs && (
          <div
            style={{
              textAlign: 'center',
              padding: '30px 12px',
              color: theme.textTertiary,
            }}
          >
            <FaRegClock style={{ fontSize: '30px', color: theme.textTertiary }} />
            <div
              style={{
                fontSize: '13px',
                fontWeight: 600,
                color: theme.textSecondary,
                marginTop: '10px',
              }}
            >
              Sin versiones guardadas
            </div>
            <div style={{ fontSize: '12px', marginTop: '2px' }}>
              Los cambios que guardes aparecerán aquí.
            </div>
          </div>
        )}

        {hasLogs && (
          <div style={{ position: 'relative' }}>
            {/* Riel vertical del timeline */}
            <div
              style={{
                position: 'absolute',
                left: '6px',
                top: '10px',
                bottom: '10px',
                width: '2px',
                backgroundColor: theme.border,
              }}
            />
            {listLogs.map((log, index) => {
              const active = selectedLog === index;
              return (
                <div
                  key={index}
                  onClick={() => {
                    selectLog(log);
                    setSelectedLog(index);
                  }}
                  style={{
                    position: 'relative',
                    display: 'flex',
                    gap: '14px',
                    cursor: 'pointer',
                    paddingBottom: index === listLogs.length - 1 ? 0 : '10px',
                  }}
                >
                  {/* Punto del timeline */}
                  <div
                    style={{
                      position: 'relative',
                      zIndex: 1,
                      width: '14px',
                      flexShrink: 0,
                      display: 'flex',
                      justifyContent: 'center',
                      paddingTop: '14px',
                    }}
                  >
                    <span
                      style={{
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        backgroundColor: active ? ACCENT : theme.panelBg,
                        border: `2px solid ${active ? ACCENT : theme.textTertiary}`,
                        boxShadow: `0 0 0 3px ${theme.panelBg}`,
                      }}
                    />
                  </div>

                  {/* Tarjeta de la versión */}
                  <div
                    style={{
                      flex: 1,
                      minWidth: 0,
                      padding: '10px 12px',
                      borderRadius: '8px',
                      border: `1px solid ${active ? `color-mix(in srgb, ${ACCENT} 50%, var(--su-surface, #ffffff))` : theme.border}`,
                      backgroundColor: active ? `color-mix(in srgb, ${ACCENT} 8%, var(--su-surface, #ffffff))` : theme.inputBg,
                      transition: 'all 0.15s ease',
                    }}
                    onMouseEnter={(e) => {
                      if (!active) e.currentTarget.style.borderColor = `color-mix(in srgb, ${ACCENT} 35%, var(--su-surface, #ffffff))`;
                    }}
                    onMouseLeave={(e) => {
                      if (!active) e.currentTarget.style.borderColor = theme.border;
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        fontSize: '12px',
                        fontWeight: 600,
                        color: theme.textPrimary,
                      }}
                    >
                      <FaRegClock style={{ fontSize: '12px', color: ACCENT, flexShrink: 0 }} />
                      {dayjs(log.created)
                        .locale('es')
                        .format('DD [de] MMMM [del] YYYY · HH:mm')}
                    </div>
                    <div
                      style={{
                        fontSize: '12px',
                        color: theme.textSecondary,
                        marginTop: '3px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      Creado por{' '}
                      <strong style={{ color: theme.textPrimary }}>
                        {log.user.length > 20
                          ? log.user.substring(0, 19) + '...'
                          : log.user}
                      </strong>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </SidePanel>
  );
};

export default HistoryVersions;
